import { useNavigate } from 'react-router-dom';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

import { Input } from './types';

import * as S from './Form.styles';

type FormProps = {
  onSubmit: () => void;
  inputs: Input[];
  buttonLabel: string;
  error?: string | Error;
  messageTitle?: string;
  register: UseFormRegister<FieldValues>;
  type?: 'login' | 'signup' | 'newPassword' | 'forgotPassword';
  hasForgotPassword?: boolean;
  hasBackButton?: boolean;
};

const defaultProps: Partial<FormProps> = {
  error: undefined,
  type: 'newPassword',
  messageTitle: undefined,
  hasForgotPassword: false,
  hasBackButton: false,
};

export function Form(props: FormProps): React.ReactElement {
  const {
    onSubmit,
    buttonLabel,
    error,
    messageTitle,
    inputs,
    register,
    hasForgotPassword,
    type,
    hasBackButton,
  } = {
    ...defaultProps,
    ...props,
  };

  const navigate = useNavigate();

  const inputsMapped = inputs?.map((input: Input) => (
    <S.LoginInput
      key={input.name}
      data-testid={input.name}
      name={input.name}
      label={input.label}
      options={{ required: true }}
      register={register}
      type={input.type}
      motive="login"
      hasShowIcon={input.type === 'password'}
      hasAutoComplete={input.autocomplete}
    />
  ));

  const setTitle = () => {
    switch (type) {
      case 'login':
        return 'Welcome back';
      case 'forgotPassword':
        return 'Reset password';
      default:
        return 'Colmar Admin Panel';
    }
  };
  const title = setTitle();

  return (
    <S.Container>
      {hasBackButton ? (
        <Button
          iconLeft="FiChevronLeft"
          $iconSize="2"
          onClick={() => navigate(-1)}
          motive="backSecondary"
          scale="s"
        >
          Back
        </Button>
      ) : null}

      <S.Title
        fontFamily="LFT Zeno Condensed"
        textAlign="center"
        color="black"
        fontWeight="extraBold"
        tag="h2"
        scale="xl"
      >
        {title}
      </S.Title>

      <S.MessageContainer>
        {messageTitle && (
          <Headline scale="xs" color="borderColorDarkSecondary" textAlign="center">
            {messageTitle}
          </Headline>
        )}
      </S.MessageContainer>

      <S.Form onSubmit={onSubmit}>
        {error && <S.ErrorMessage>{error.toString()}</S.ErrorMessage>}

        {inputsMapped}

        <S.Wrapper>
          {hasForgotPassword ? (
            <S.ForgotPassword
              type="button"
              onClick={() => navigate('forgot-password')}
              motive="forgotPassword"
              scale="xs"
            >
              Forgot Password?
            </S.ForgotPassword>
          ) : null}

          <Button
            type="submit"
            motive="blackAccept"
            scale="lg"
            fontFamily="LFT Zeno Condensed"
          >
            {buttonLabel}
          </Button>
        </S.Wrapper>
      </S.Form>
    </S.Container>
  );
}
